import { CircleIcon } from "common/Icons"
import { FC } from "react";
import FormTwoFactor from "./components/form";

type IMobileOtpModuleType = {
    handleSubmitOtp: (data: ISubmitOtpModuleType) => void
}


const MobileOtpModule: FC<IMobileOtpModuleType> = ({ handleSubmitOtp }) => {


    return (
        <div className='bg-L-gray-50 h-[100vh] inset-0 relative'>
            <div>
                <div className="absolute top-[27px] left-[calc(50%-96px)]">
                    <CircleIcon width={83} height={83} />
                </div>
                <div className='flex justify-center pt-12 z-10 relative'>
                    <img src="/assets/images/otpPage.svg" alt='test' width={69} height={133} />
                </div>
            </div>

            <FormTwoFactor {...{ handleSubmitOtp }} />

        </div>
    )
}

export default MobileOtpModule